export const cookieApiTokenKey = 'CakeCookie[gsskt_token]';
export const cookieApiRefreshTokenKey = 'CakeCookie[gsskt_refresh_token]';
